import axiosInstance from './axiosInstance';
import { SessionResponse, ApiResponse, SessionData } from './interfaces/ApiInterfaces';

// Fonction pour créer une session
export const createSession = async (): Promise<SessionResponse> => {
  try {
    const response = await axiosInstance.post<ApiResponse<SessionResponse>>('/session/login', {});
    if (response.status === 200) {
      console.log('Session créée avec succès:', response.data.data);
      return response.data.data;
    } else {
      throw new Error('Erreur lors de la création de session');
    }
  } catch (error) {
    console.error('Erreur lors de la création de session:', error);
    throw error;
  }
};


// Fonction pour vérifier si une session existe
export const isAuthenticated = (): boolean => {
  const sessionData = sessionStorage.getItem('hectorSession');
  if (!sessionData) return false;
  
  try {
    const parsedData = JSON.parse(sessionData);
    return !!(parsedData.sessionId && parsedData.accessToken);
  } catch {
    return false;
  }
};

// Fonction pour récupérer l'ID de session
export const getSessionId = (): string | null => {
  const sessionData = sessionStorage.getItem('hectorSession');
  if (!sessionData) return null;
  
  try {
    const parsedData = JSON.parse(sessionData);
    return parsedData.sessionId || null;
  } catch {
    return null;
  }
};

// Fonction pour sauvegarder la session
export const setSession = (sessionId: string, accessToken: string): void => {
  const sessionData = {
    sessionId,
    accessToken,
    timestamp: new Date().toISOString()
  };
  sessionStorage.setItem('hectorSession', JSON.stringify(sessionData));
};

// Fonction pour nettoyer la session
export const clearSession = (): void => {
  sessionStorage.removeItem('hectorSession');
};

// Fonction principale pour s'assurer qu'une session existe
export const ensureSession = async (): Promise<SessionData | null> => {
  const sessionId = getSessionId();
  
  if (!sessionId || !isAuthenticated()) {
    console.log('Création d\'une nouvelle session...');
    try {
      const sessionData = await createSession();
      if (sessionData.sessionId && sessionData.accessToken) {
        setSession(sessionData.sessionId, sessionData.accessToken);
        
        const completeSessionData: SessionData = {
          sessionId: sessionData.sessionId,
          accessToken: sessionData.accessToken,
        };
        
        console.log('Session complète créée avec succès:', completeSessionData);
        return completeSessionData;
      } else {
        throw new Error('Données de session incomplètes');
      }
    } catch (error) {
      console.error('Erreur lors de la création de session:', error);
      return null;
    }
  } else {
    console.log('Session existante trouvée:', sessionId);
    try {
      // Récupérer les informations techniques pour la session existante
      const sessionData = JSON.parse(sessionStorage.getItem('hectorSession') || '{}');
      
      const completeSessionData: SessionData = {
        sessionId: sessionData.sessionId,
        accessToken: sessionData.accessToken,
      };
      
      return completeSessionData;
    } catch (error) {
      console.error('Erreur lors de la récupération des informations techniques:', error);
      return await ensureSession();
    }
  }
};
